import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

import IconGear from './icon-gear.svg'

export default function PartnerTools() {
  const { t } = useTranslation()

  return (
    <div className={cn('container', styles.container)}>
      <h2>{t('partner_tools_section')}</h2>
      <div>
        <div className={styles.iconsBlock}>
          <img src={IconGear} alt="IconGear" width={50} height={50} />
          <p>{t('partner_api_description')}</p>
          <a
            href="https://documenter.getpostman.com/view/18567220/UVeNnP5y"
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            <button>{t('check_docs')}</button>
          </a>
        </div>
        <div className={styles.iconsBlock}>
          <img src={IconGear} alt="IconGear" width={50} height={50} />
          <p>
            {t('whitelabel_solution')}
            {' '}
            {t('integration_time_period')}
          </p>
        </div>
        <div className={styles.iconsBlock}>
          <img src={IconGear} alt="IconGear" width={50} height={50} />
          <p>{t('custom_tool_development')}</p>
        </div>
      </div>
    </div>
  )
}
